import React, {useEffect, useState} from "react";
import Lotto5Nav from "./Lotto5Nav";
import {useDispatch, useSelector} from "react-redux";
import {fetchLotto5ResultReport} from "../../store/rootAction";
import moment from "moment";
import "moment-timezone";
import {useTranslation} from "react-i18next";
import DatePicker from "react-datepicker";
import {currentDate, getDateDef} from "../../utils/dateUtils";
import {lottoPaths} from "../../constants/general";
import LottoMixNav from "../lotto/mix/LottoMixNav";
import MainTableResult from "./MainTableResult";

export default function Lotto5Result(props) {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    // You can select more as needed
    const state = useSelector(state => state.lotto5.resultLotto5Report);
    const {filter} = state;
    // If you need other pieces of state, add more useSelector calls.

    const [date, setDate] = useState(currentDate());

    // Initial fetch
    useEffect(() => {
        dispatch(fetchLotto5ResultReport({...filter, filterDate: getDateDef(date)}));
        // eslint-disable-next-line
    }, []);

    const onFilter = (params = {}) => {
        dispatch(fetchLotto5ResultReport({...filter, filterDate: getDateDef(date), ...params}));
    };


    let isFrame = lottoPaths.includes(props.location?.pathname);


    return (
        <div className="main-w">
            <div className="main">
                <div className="w-1200">
                    <div className="wrapper-game-content">
                        {isFrame ? <LottoMixNav {...props} /> : <Lotto5Nav/>}
                        <div>
                            <div className="row align-items-center ml-3 mt-2 pb-0">
                                <div className="form-date-range">
                                    <label>{t("labels:drawing.date")}:</label>
                                </div>
                                <div className="pl-2">
                                    <DatePicker
                                        dateFormat="dd-MM-yyyy"
                                        selected={date}
                                        maxDate={moment().toDate()}
                                        onChange={setDate}
                                        className="form-control bg-white"
                                    />
                                </div>
                                <div className="wrap-btn-filter">
                                    <button className="btn-game" onClick={() => onFilter()}>
                                        {t("labels:common.getResult")}
                                    </button>
                                </div>
                            </div>

                            <MainTableResult onChangePage={onFilter}  {...state}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
